import { PureComponent } from 'react'
import { useMediaQuery } from 'react-responsive'
import { CSSTransition } from 'react-transition-group'

const MediaQueryComponent = ({ children }) => {
    const isSmallScreen = useMediaQuery({ maxWidth: '700px' })

    return (
        <CSSTransition
            in={true}
            classNames={isSmallScreen ? 'mobMount' : 'onMount'}
            appear={true}
            unmountOnExit
            timeout={400}
        >
            {children}
        </CSSTransition>
    )
}

class OnMountTransition extends PureComponent {
    render() {
        if (typeof window !== 'undefined') {
            return (
                <MediaQueryComponent>{this.props.children}</MediaQueryComponent>
            )
        } else {
            return this.props.children
        }
    }
}

export default OnMountTransition
